import { ReactComponent as Icon } from './raw/Weapon_crossed-swords.svg'
import { SvgIcon, SvgIconProps } from "@mui/material";

const WeaponIcon = (props: SvgIconProps) => {
    return (
      <SvgIcon {...props}>
        <Icon />
      </SvgIcon>
    );
  }

export default WeaponIcon;